import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, message, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './styles.less';

const FileSelect = ({
  children,
  onChange,
  onFileListChange,
  maxSizeKb,
  maxFileCount,
  defaultFileList,
  enableFileList,
  onRemove,
  ...props
}) => {
  const [hasUploaded, setHasUploaded] = useState(defaultFileList?.length > 0);
  const multipleFiles = maxFileCount > 1;

  const handleUpload = (file) => {
    if (maxSizeKb && file.size > maxSizeKb * 1024) {
      message.warning('El archivo es demasiado pesado.');
      return Upload.LIST_IGNORE;
    }
    setHasUploaded(true);
    onChange(file);
    return false;
  };

  const handleChange = (info) => {
    onFileListChange?.(info.fileList);
    if (multipleFiles) {
      onChange(info.fileList);
    }
    if (info.file.status === 'removed') {
      onChange(undefined);
      setHasUploaded(false);
    }
  };

  const handleRemove = (file) => {
    setHasUploaded(false);
    onRemove?.(file);
  };

  const cleanedProps = { ...props };
  delete cleanedProps.value;

  return multipleFiles ? (
    <Upload
      className="multiple-upload"
      onChange={handleChange}
      onRemove={handleRemove}
      maxCount={maxFileCount}
      fileList={props.value}
      beforeUpload={handleUpload}
      defaultFileList={props.value}
      {...cleanedProps}
    >
      <Button className="upload__button">
        <UploadOutlined className="upload__button-icon" />
        <span className="upload__button-content">{children}</span>
      </Button>
    </Upload>
  ) : (
    <Upload
      as="div"
      className="single-upload"
      listType="picture"
      onChange={handleChange}
      onRemove={handleRemove}
      maxCount={maxFileCount}
      fileList={enableFileList ? props.value : undefined}
      beforeUpload={handleUpload}
      defaultFileList={defaultFileList}
      {...cleanedProps}
    >
      {!hasUploaded && (
        <Button className="upload__button">
          <UploadOutlined className="upload__button-icon" />
          <span className="upload__button-content">{children}</span>
        </Button>
      )}
    </Upload>
  );
};

FileSelect.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  onFileListChange: PropTypes.func,
  maxSizeKb: PropTypes.number,
  maxFileCount: PropTypes.number,
  defaultFileList: PropTypes.arrayOf(PropTypes.shape),
  fileList: PropTypes.arrayOf(PropTypes.shape),
  enableFileList: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.shape),
  onRemove: PropTypes.func,
};

FileSelect.defaultProps = {
  onChange: undefined,
  onFileListChange: undefined,
  maxSizeKb: undefined,
  defaultFileList: undefined,
  fileList: undefined,
  maxFileCount: 1,
  enableFileList: false,
  value: undefined,
  onRemove: undefined,
};

export default FileSelect;
